
import {
  Component,
  Vue,
  Prop,
  PropSync,
  Ref,
  Watch,
} from "vue-property-decorator";
import { StorageFilters } from "@/models/entities/storage/storageFilters.interface";
import FiltersStorageModule from "@/store/modules/storage/filtersStorage.module";
import SnackBarModule from "@/store/modules/core/snackbar.module";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import { storageService } from "@/services/api/storage.service";
import {
  FilterParameters,
  filterStructure,
} from "@/models/entities/storage/storageInput/storageInput.interface";
import rowNavigationDrawer from "@/components/core/rowNavigationDrawer.vue";
const storageModule = getModule(FiltersStorageModule, store);
const snackbarModule = getModule(SnackBarModule, store);
@Component({
  components: {
    rowNavigationDrawer,
  },
})
export default class NavigationDrawerFilters extends Vue {
  private tab = null;
  private expand = false;
  @Prop({ required: false, default: null }) currentFilters: StorageFilters;
  @Prop({ required: false, default: null }) userName: string;
  @Prop({ required: false, default: null }) adminUsers: string[];
  @Prop({ required: false, default: 0 }) toggle_buttons: number;
  //array filtri
  private categoriaFilterValue: filterStructure[] = [];
  private storeFilterValue: filterStructure[] = [];
  private brandFilterValue: filterStructure[] = [];
  private cartypeFilterValue: filterStructure[] = [];
  private fromYearFilterValue: filterStructure[] = [];
  private typeFilterValue: filterStructure[] = [];
  private canaleFilterValue: filterStructure[] = [];
  private diametroFilterValue: filterStructure[] = [];
  private foriFilterValue: filterStructure[] = [];
  private pcdFilterValue: filterStructure[] = [];
  private et_FromFilterValue: filterStructure[] = [];
  private et_ToFilterValue: filterStructure[] = [];
  private foroCentrale_FromFilterValue: filterStructure[] = [];
  private foroCentrale_ToFilterValue: filterStructure[] = [];
  private groupFilterValue: filterStructure[] = [];
  private tireFilterValue: filterStructure[] = [];
  private categoryFilterValue: filterStructure[] = [];
  private heightFilterValue: filterStructure[] = [];
  private modelloRuotaFilterValue: filterStructure[] = [];
  private finituraFilterValue: filterStructure[] = [];

  private source: AbortController = null;

  private isActive = false;

  private valid = false;

  private rules = {
    select: [(v) => !!v || "Richiesto!"],
  };

  private filtersValue: StorageFilters = {
    requestType: 0,
    includeGiancezaZero: false,
    onlyMoreThanFour: false,
    codice: null,
    keywords: null,
    keywords2: null,
    categoria: null,
    catalogueSourceID: null,
    brand: null,
    cartype: null,
    fromYear: null,
    type: null,
    model: null,
    canale: null,
    diametro: null,
    fori: null,
    pcd: null,
    et_From: null,
    et_To: null,
    foroCentrale_From: null,
    foroCentrale_To: null,
    tireDimension: null,
    height: null,
    category: null,
    modelloRuota: null,
    finitura: null,
  };

  private formatDate(date): string {
    if (!date) return null;
    const [year, month, day, hour] = date
      .replace("T", "-")
      .replace(".", "-")
      .split("-");
    return `${day}/${month}/${year} alle ore: ${hour}`;
  }

  @Ref("form") readonly form!: HTMLFormElement;
  @PropSync("visible") private drawer: boolean;

  @Watch("currentFilters")
  currentFiltersChanged(): void {
    if (this.currentFilters != null) {
      this.filtersValue.includeGiancezaZero =
        this.currentFilters.includeGiancezaZero != null
          ? this.currentFilters.includeGiancezaZero
          : this.filtersValue.includeGiancezaZero;

      this.filtersValue.onlyMoreThanFour =
        this.currentFilters.onlyMoreThanFour != null
          ? this.currentFilters.onlyMoreThanFour
          : this.filtersValue.onlyMoreThanFour;

      this.filtersValue.codice =
        (this.filtersValue.codice == null || this.filtersValue.codice == "") &&
        this.currentFilters.codice != null
          ? this.currentFilters.codice
          : this.filtersValue.codice;

      this.filtersValue.keywords =
        (this.filtersValue.keywords == null ||
          this.filtersValue.keywords == "") &&
        this.currentFilters.keywords != null
          ? this.currentFilters.keywords
          : this.filtersValue.keywords;
      this.filtersValue.keywords2 =
        (this.filtersValue.keywords2 == null ||
          this.filtersValue.keywords2 == "") &&
        this.currentFilters.keywords2 != null
          ? this.currentFilters.keywords2
          : this.filtersValue.keywords2;

      this.filtersValue.categoria =
        (this.filtersValue.categoria == null ||
          this.filtersValue.categoria == "") &&
        this.currentFilters.categoria != null
          ? this.currentFilters.categoria
          : this.filtersValue.categoria;
      this.filtersValue.catalogueSourceID =
        this.filtersValue.catalogueSourceID == null &&
        this.currentFilters.catalogueSourceID != null
          ? this.currentFilters.catalogueSourceID
          : this.filtersValue.catalogueSourceID;
      this.filtersValue.brand =
        (this.filtersValue.brand == null || this.filtersValue.brand == "") &&
        this.currentFilters.brand != null
          ? this.currentFilters.brand
          : this.filtersValue.brand;
      this.filtersValue.cartype =
        (this.filtersValue.cartype == null ||
          this.filtersValue.cartype == "") &&
        this.currentFilters.cartype != null
          ? this.currentFilters.cartype
          : this.filtersValue.cartype;

      this.filtersValue.modelloRuota =
        (this.filtersValue.modelloRuota == null ||
          this.filtersValue.modelloRuota == "") &&
        this.currentFilters.modelloRuota != null
          ? this.currentFilters.modelloRuota
          : this.filtersValue.modelloRuota;

      this.filtersValue.fromYear =
        (this.filtersValue.fromYear == null ||
          this.filtersValue.fromYear == "") &&
        this.currentFilters.fromYear != null
          ? this.currentFilters.fromYear
          : this.filtersValue.fromYear;
      this.filtersValue.type =
        (this.filtersValue.type == null || this.filtersValue.type == "") &&
        this.currentFilters.type != null
          ? this.currentFilters.type
          : this.filtersValue.type;
      this.filtersValue.model =
        (this.filtersValue.model == null || this.filtersValue.model == "") &&
        this.currentFilters.model != null
          ? this.currentFilters.model
          : this.filtersValue.model;
      this.filtersValue.canale =
        this.filtersValue.canale == null && this.currentFilters.canale != null
          ? this.currentFilters.canale
          : this.filtersValue.canale;
      this.filtersValue.diametro =
        this.filtersValue.diametro == null &&
        this.currentFilters.diametro != null
          ? this.currentFilters.diametro
          : this.filtersValue.diametro;
      this.filtersValue.fori =
        this.filtersValue.fori == null && this.currentFilters.fori != null
          ? this.currentFilters.fori
          : this.filtersValue.fori;
      this.filtersValue.pcd =
        this.filtersValue.pcd == null && this.currentFilters.pcd != null
          ? this.currentFilters.pcd
          : this.filtersValue.pcd;
      this.filtersValue.et_From =
        this.filtersValue.et_From == null && this.currentFilters.et_From != null
          ? this.currentFilters.et_From
          : this.filtersValue.et_From;
      this.filtersValue.et_To =
        this.filtersValue.et_To == null && this.currentFilters.et_To != null
          ? this.currentFilters.et_To
          : this.filtersValue.et_To;
      this.filtersValue.foroCentrale_From =
        this.filtersValue.foroCentrale_From == null &&
        this.currentFilters.foroCentrale_From != null
          ? this.currentFilters.foroCentrale_From
          : this.filtersValue.foroCentrale_From;
      this.filtersValue.foroCentrale_To =
        this.filtersValue.foroCentrale_To == null &&
        this.currentFilters.foroCentrale_To != null
          ? this.currentFilters.foroCentrale_To
          : this.filtersValue.foroCentrale_To;
      this.filtersValue.tireDimension =
        (this.filtersValue.tireDimension == null ||
          this.filtersValue.tireDimension == "") &&
        this.currentFilters.tireDimension != null
          ? this.currentFilters.tireDimension
          : this.filtersValue.tireDimension;
      this.filtersValue.height =
        this.filtersValue.height == null && this.currentFilters.height != null
          ? this.currentFilters.height
          : this.filtersValue.height;

      // this.filtersValue.category =
      //   (this.filtersValue.category == null ||
      //     this.filtersValue.category == "") &&
      //   this.currentFilters.category != null
      //     ? this.currentFilters.category
      //     : this.filtersValue.category;
      storageModule.setFilters(this.filtersValue);
    }
  }

  @Watch("filtersValue.categoria")
  categoriaUpdated(): void {
    // init based on categoria
    this.catalogueDate = "";
    this.photoDate = "";
    this.priceDate = "";
    this.stockDate = "";
    this.fillSingleFilter(this.storeFilterValue, "cataloguesource");
    switch (this.filtersValue.categoria) {
      case "000":
      case "001":
        storageService
          .getLastModified(this.filtersValue.categoria, 0)
          .then((res) => {
            this.proceedWatchSourceID();
            this.catalogueDate = this.formatDate(res.data.catalogueUpdateDate);
            this.photoDate = this.formatDate(res.data.photoUpdateDate);
            this.priceDate = this.formatDate(res.data.priceUpdateDate);
            this.stockDate = this.formatDate(res.data.stockUpdateDate);
          })
          .catch((e) => {
            console.warn(e);
          });
        break;
      case "050":
      case "150":
        this.filtersValue.includeGiancezaZero = true;
        this.filtersValue.requestType = 0;
        break;
      // case "002":
      //   this.filtersValue.catalogueSourceID = "1";
      //   this.filtersValue.catalogueSourceID = "Milano ( Ruote Replica + Originali)";
      case "055":
        this.filtersValue.requestType = 1;
        break;
      // default:
      //   this.filtersValue.requestType = 0;
    }
    // fill filters
    this.fillSingleFilter(this.canaleFilterValue, "canali");
    this.fillSingleFilter(this.diametroFilterValue, "diametri");
    this.fillSingleFilter(this.et_FromFilterValue, "et");
    this.fillSingleFilter(this.et_ToFilterValue, "et");
    this.fillSingleFilter(this.brandFilterValue, "brands");
    this.fillSingleFilter(this.foriFilterValue, "fori");
    this.fillSingleFilter(this.foroCentrale_FromFilterValue, "foricentrali");
    this.fillSingleFilter(this.foroCentrale_ToFilterValue, "foricentrali");
    this.fillSingleFilter(this.pcdFilterValue, "pcd");
    //  this.fillSingleFilter(this.storeFilterValue, "cataloguesource");
  }
  @Watch("filtersValue.brand")
  brandsUpdated(): void {
    this.filtersValue.model = null;
    this.filtersValue.foroCentrale_From = null;
    this.filtersValue.foroCentrale_To = null;
    if (this.filtersValue.brand != null && this.filtersValue.brand != "") {
      this.fillSingleFilter(this.cartypeFilterValue, "models");
      this.fillSingleFilter(this.foroCentrale_FromFilterValue, "foricentrali");
      this.fillSingleFilter(this.foroCentrale_ToFilterValue, "foricentrali");
    }
  }
  @Watch("filtersValue.model")
  modelUpdated(): void {
    this.filtersValue.fromYear = null;
    if (this.filtersValue.model != null && this.filtersValue.model != "") {
      this.fillSingleFilter(this.fromYearFilterValue, "fromyears");
    }
  }
  @Watch("filtersValue.fromYear")
  fromYearUpdated(): void {
    this.filtersValue.cartype = null;
    this.filtersValue.modelloRuota = null;
    this.filtersValue.finitura = null;
    if (
      this.filtersValue.fromYear != null &&
      this.filtersValue.fromYear != ""
    ) {
      this.fillSingleFilter(this.typeFilterValue, "cartypes");
    }
  }

  private proceedWatchSourceID(): void {
    this.filtersValue.tireDimension = null;
    //  this.filtersValue.category = null;
    this.filtersValue.height = null;
    this.filtersValue.brand = null;
    this.filtersValue.model = null;
    this.filtersValue.fromYear = null;
    this.filtersValue.cartype = null;
    this.filtersValue.modelloRuota = null;
    this.filtersValue.finitura = null;
    this.filtersValue.diametro = null;

    if (this.filtersValue.catalogueSourceID != null) {
      this.fillSingleFilter(this.brandFilterValue, "brands");
      this.fillSingleFilter(this.cartypeFilterValue, "models");
      this.fillSingleFilter(this.fromYearFilterValue, "fromyears");
      this.fillSingleFilter(this.typeFilterValue, "cartypes");

      if (
        this.filtersValue.catalogueSourceID != null &&
        this.filtersValue.catalogueSourceID == 10
      ) {
        this.fillSingleFilter(this.groupFilterValue, "diametri");
      } else {
        this.groupFilterValue = [];
      }

      if (
        this.filtersValue.catalogueSourceID != null &&
        this.filtersValue.catalogueSourceID == 11
      ) {
        this.fillSingleFilter(this.tireFilterValue, "tires");
      } else {
        this.tireFilterValue = [];
      }

      if (this.filtersValue.catalogueSourceID == 12) {
        this.fillSingleFilter(this.categoryFilterValue, "categorykonig");
        this.fillSingleFilter(this.canaleFilterValue, "canalebykonigcategory");
      } else {
        this.categoryFilterValue = [];
      }
    }
  }

  private catalogueDate = "";
  private photoDate = "";
  private priceDate = "";
  private stockDate = "";

  @Watch("filtersValue.catalogueSourceID")
  storeUpdated(): void {
    // Separated logic: if Bracchi show last modified
    if (
      this.filtersValue.catalogueSourceID == "1" ||
      this.filtersValue.catalogueSourceID == null
    ) {
      // ALSO HIDE FILTER MODELLO RUOTA

      this.proceedWatchSourceID();
    } else {
      if (this.adminUsers.includes(this.userName)) {
        storageService
          .getLastModified(
            this.filtersValue.categoria,
            this.filtersValue.catalogueSourceID
          )
          .then((res) => {
            this.proceedWatchSourceID();
            this.catalogueDate = this.formatDate(res.data.catalogueUpdateDate);
            this.photoDate = this.formatDate(res.data.photoUpdateDate);
            this.priceDate = this.formatDate(res.data.priceUpdateDate);
            this.stockDate = this.formatDate(res.data.stockUpdateDate);
          })
          .catch((e) => {
            console.warn(e);
          });
      } else {
        this.proceedWatchSourceID();
      }
    }
  }

  @Watch("filtersValue.tireDimension")
  tireUpdated(): void {
    this.filtersValue.canale = null;
    this.filtersValue.height = null;
    this.filtersValue.diametro = null;
    if (
      this.filtersValue.tireDimension != null &&
      this.filtersValue.tireDimension != ""
    ) {
      this.groupFilterValue = [];
      this.fillSingleFilter(this.groupFilterValue, "groupbytire");
    }
  }

  @Watch("filtersValue.category")
  categoryKonigUpdated(): void {
    // imposto canale
    this.filtersValue.canale = null;
    this.filtersValue.height = null;
    this.filtersValue.diametro = null;
    //  if (
    //    this.filtersValue.category != null &&
    //    this.filtersValue.category != ""
    //  ) {
    this.canaleFilterValue = [];
    this.fillSingleFilter(this.canaleFilterValue, "canalebykonigcategory");
    //  }
  }
  @Watch("filtersValue.canale")
  canaleKonigUpdated(): void {
    // imposto altezza
    this.filtersValue.height = null;
    if (this.filtersValue.categoria == "150") this.filtersValue.diametro = null;
    if (this.filtersValue.canale != null) {
      this.heightFilterValue = [];
      this.fillSingleFilter(this.heightFilterValue, "heightbykonigcategory");
    }
  }
  @Watch("filtersValue.height")
  heightKonigUpdated(): void {
    // imposto gruppo
    this.filtersValue.diametro = null;
    if (this.filtersValue.height != null) {
      this.groupFilterValue = [];
      this.fillSingleFilter(this.groupFilterValue, "groupbykonigcategory");
    }
  }
  @Watch("filtersValue.cartype")
  cartypeUpdated(): void {
    this.filtersValue.diametro = null;
    this.filtersValue.fori = null;
    this.filtersValue.foroCentrale_From = null;
    this.filtersValue.foroCentrale_To = null;
    this.filtersValue.pcd = null;
    this.filtersValue.canale = null;
    this.filtersValue.et_From = null;
    this.filtersValue.et_To = null;
    this.filtersValue.modelloRuota = null;

    if (this.filtersValue.cartype != null && this.filtersValue.cartype != "") {
      this.canaleFilterValue = [];
      this.diametroFilterValue = [];
      this.foriFilterValue = [];
      this.pcdFilterValue = [];
      this.et_FromFilterValue = [];
      this.et_ToFilterValue = [];
      this.foroCentrale_FromFilterValue = [];
      this.foroCentrale_ToFilterValue = [];
      this.modelloRuotaFilterValue = [];

      this.fillSingleFilter(this.modelloRuotaFilterValue, "wheelmodels");
      this.fillSingleFilter(this.canaleFilterValue, "canalibymodel");
      this.fillSingleFilter(this.diametroFilterValue, "diametersbymodel");
      this.fillSingleFilter(this.foriFilterValue, "holesbymodel");
      this.fillSingleFilter(this.pcdFilterValue, "pcdsbymodel");
      this.fillSingleFilter(this.foroCentrale_FromFilterValue, "cbsbymodel");
      this.fillSingleFilter(this.foroCentrale_ToFilterValue, "cbsbymodel");
    }
  }
  @Watch("filtersValue.modelloRuota")
  modelloRuotaUpdated(): void {
    this.filtersValue.diametro = null;
    this.filtersValue.fori = null;
    this.filtersValue.foroCentrale_From = null;
    this.filtersValue.foroCentrale_To = null;
    this.filtersValue.pcd = null;
    this.filtersValue.canale = null;
    this.filtersValue.et_From = null;
    this.filtersValue.et_To = null;
    this.filtersValue.finitura = null;
    this.finituraFilterValue = [];
    this.fillSingleFilter(this.finituraFilterValue, "finishing");
    //fill filtri sottostanti
    this.canaleFilterValue = [];
    this.diametroFilterValue = [];
    this.foriFilterValue = [];
    this.pcdFilterValue = [];
    this.et_FromFilterValue = [];
    this.et_ToFilterValue = [];
    this.foroCentrale_FromFilterValue = [];
    this.foroCentrale_ToFilterValue = [];
    this.fillSingleFilter(this.canaleFilterValue, "canalibymodel");
    this.fillSingleFilter(this.diametroFilterValue, "diametersbymodel");
    this.fillSingleFilter(this.foriFilterValue, "holesbymodel");
    this.fillSingleFilter(this.pcdFilterValue, "pcdsbymodel");
    this.fillSingleFilter(this.foroCentrale_FromFilterValue, "cbsbymodel");
    this.fillSingleFilter(this.foroCentrale_ToFilterValue, "cbsbymodel");
  }
  @Watch("filtersValue.finitura")
  finituraUpdated(): void {
    this.filtersValue.diametro = null;
    this.filtersValue.fori = null;
    this.filtersValue.foroCentrale_From = null;
    this.filtersValue.foroCentrale_To = null;
    this.filtersValue.pcd = null;
    this.filtersValue.canale = null;
    this.filtersValue.et_From = null;
    this.filtersValue.et_To = null;
    this.canaleFilterValue = [];
    this.diametroFilterValue = [];
    this.foriFilterValue = [];
    this.pcdFilterValue = [];
    this.et_FromFilterValue = [];
    this.et_ToFilterValue = [];
    this.foroCentrale_FromFilterValue = [];
    this.foroCentrale_ToFilterValue = [];
    this.fillSingleFilter(this.canaleFilterValue, "canalibymodel");
    this.fillSingleFilter(this.diametroFilterValue, "diametersbymodel");
    this.fillSingleFilter(this.foriFilterValue, "holesbymodel");
    this.fillSingleFilter(this.pcdFilterValue, "pcdsbymodel");
    this.fillSingleFilter(this.foroCentrale_FromFilterValue, "cbsbymodel");
    this.fillSingleFilter(this.foroCentrale_ToFilterValue, "cbsbymodel");
  }

  @Watch("filtersValue.diametro")
  diametroUpdated(): void {
    if (this.filtersValue.cartype != null && this.filtersValue.cartype != "") {
      this.filtersValue.et_From = null;
      this.filtersValue.et_To = null;
      if (this.filtersValue.diametro != null) {
        this.et_FromFilterValue = [];
        this.et_ToFilterValue = [];
        this.fillSingleFilter(this.et_FromFilterValue, "etsbymodel");
        this.fillSingleFilter(this.et_ToFilterValue, "etsbymodel");
      }
    }
  }

  @Watch("filtersValue.onlyMoreThanFour")
  onlyMoreThanFourUpdated(): void {
    if (this.filtersValue.onlyMoreThanFour) {
      this.filtersValue.includeGiancezaZero = false;
    }
    this.$emit("changeOnlyMoreThanFour", this.filtersValue.onlyMoreThanFour);
  }

  @Watch("filtersValue.includeGiancezaZero")
  includeGiancezaZeroUpdated(): void {
    if (this.filtersValue.includeGiancezaZero) {
      this.filtersValue.onlyMoreThanFour = false;
    }
  }

  private requestTypeUpdated(): void {
    if (this.filtersValue.requestType == 1) {
      this.filtersValue.catalogueSourceID = 1;
      this.filtersValue.canale = null;
      this.filtersValue.diametro = null;
      this.filtersValue.fori = null;
      this.filtersValue.pcd = null;
      this.filtersValue.et_From = null;
      this.filtersValue.foroCentrale_From = null;
      this.filtersValue.et_To = null;
      this.filtersValue.foroCentrale_To = null;
      this.canaleFilterValue = [];
      this.diametroFilterValue = [];
      this.foriFilterValue = [];
      this.pcdFilterValue = [];
      this.et_FromFilterValue = [];
      this.et_ToFilterValue = [];
      this.foroCentrale_FromFilterValue = [];
      this.foroCentrale_ToFilterValue = [];
      this.fillSingleFilter(this.canaleFilterValue, "canali");
      this.fillSingleFilter(this.diametroFilterValue, "diametri");
      this.fillSingleFilter(this.et_FromFilterValue, "et");
      this.fillSingleFilter(this.et_ToFilterValue, "et");
      this.fillSingleFilter(this.foriFilterValue, "fori");
      this.fillSingleFilter(this.foroCentrale_FromFilterValue, "foricentrali");
      this.fillSingleFilter(this.foroCentrale_ToFilterValue, "foricentrali");
      this.fillSingleFilter(this.pcdFilterValue, "pcd");
    } else {
      this.filtersValue.catalogueSourceID = null;
    }
  }

  get configuratoreConditionsBottom(): boolean {
    //return if bottom filters are disabled
    if (
      this.filtersValue.categoria == null ||
      this.filtersValue.categoria == "000" ||
      this.filtersValue.categoria == "001" ||
      this.filtersValue.categoria == "002"
    ) {
      if (!this.configuratore) {
        return false;
      } else if (
        this.configuratore &&
        this.filtersValue.model != null &&
        this.filtersValue.cartype != null &&
        this.filtersValue.brand != null &&
        this.filtersValue.fromYear != null
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  get confirmRulesConfiguratore(): boolean {
    if (
      this.configuratore &&
      (this.filtersValue.categoria == "000" ||
        this.filtersValue.categoria == "001" ||
        this.filtersValue.categoria == "002")
    ) {
      return true;
    }
    return false;
  }

  get configuratore(): boolean {
    return this.filtersValue.brand != null ? true : false;
  }

  private expandMenu(): void {
    this.expand = !this.expand;
  }

  mounted(): void {
    //fill filtro principale (categorie)
    this.fillGenericFilter(this.categoriaFilterValue, "categoria", null);
    if (storageModule.getFilters != null) {
      //imposto valori già presenti
      this.filtersValue = storageModule.getFilters;
      this.fillAll();
    } else {
      this.resetFilters();
    }
    this.isActive = true;
  }

  private fillAll(): void {
    let filtersObject: FilterParameters = {
      brand: this.filtersValue.brand,
      model: this.filtersValue.model,
      fromYear: this.filtersValue.fromYear,
      carType: this.filtersValue.cartype,
      category: this.filtersValue.categoria,
      catalogueSourceID:
        this.filtersValue.catalogueSourceID == null
          ? null
          : this.filtersValue.catalogueSourceID.toString(),
      snowChainID: this.filtersValue.category,
      tire: this.filtersValue.tireDimension,
      height:
        this.filtersValue.height == null
          ? null
          : this.filtersValue.height.toString(),
      canali:
        this.filtersValue.canale == null
          ? null
          : this.filtersValue.canale.toString(),
      diametro:
        this.filtersValue.diametro == null
          ? null
          : this.filtersValue.diametro.toString(),
      finishing: this.filtersValue.finitura,
      wheelModel: this.filtersValue.modelloRuota,
    };
    this.fillGenericFilter(this.brandFilterValue, "brands", filtersObject);
    this.fillGenericFilter(this.cartypeFilterValue, "models", filtersObject);
    this.fillGenericFilter(this.typeFilterValue, "cartypes", filtersObject);
    this.fillGenericFilter(
      this.fromYearFilterValue,
      "fromyears",
      filtersObject
    );
    this.fillGenericFilter(this.canaleFilterValue, "canali", filtersObject);
    this.fillGenericFilter(this.diametroFilterValue, "diametri", filtersObject);
    this.fillGenericFilter(this.foriFilterValue, "fori", filtersObject);
    this.fillGenericFilter(
      this.foroCentrale_FromFilterValue,
      "foricentrali",
      filtersObject
    );
    this.fillGenericFilter(
      this.foroCentrale_ToFilterValue,
      "foricentrali",
      filtersObject
    );
    this.fillGenericFilter(this.et_FromFilterValue, "et", filtersObject);
    this.fillGenericFilter(this.et_ToFilterValue, "et", filtersObject);
    this.fillGenericFilter(this.pcdFilterValue, "pcd", filtersObject);
    this.fillGenericFilter(
      this.storeFilterValue,
      "cataloguesource",
      filtersObject
    );
    this.fillGenericFilter(this.groupFilterValue, "diametri", filtersObject);
    this.fillGenericFilter(this.tireFilterValue, "tires", filtersObject);
    this.fillGenericFilter(
      this.categoryFilterValue,
      "categorykonig",
      filtersObject
    );
  }

  private fillSingleFilter(
    filterStructure: filterStructure[],
    filterName: string
  ): void {
    let filtersObject: FilterParameters = {
      brand: this.filtersValue.brand,
      model: this.filtersValue.model,
      fromYear: this.filtersValue.fromYear,
      carType: this.filtersValue.cartype,
      category: this.filtersValue.categoria,
      catalogueSourceID:
        this.filtersValue.catalogueSourceID == null
          ? null
          : this.filtersValue.catalogueSourceID.toString(),
      snowChainID: this.filtersValue.category,
      tire: this.filtersValue.tireDimension,
      height:
        this.filtersValue.height == null
          ? null
          : this.filtersValue.height.toString(),
      canali:
        this.filtersValue.canale == null
          ? null
          : this.filtersValue.canale.toString(),
      diametro:
        this.filtersValue.diametro == null
          ? null
          : this.filtersValue.diametro.toString(),
      finishing: this.filtersValue.finitura,
      wheelModel: this.filtersValue.modelloRuota,
    };
    this.fillGenericFilter(filterStructure, filterName, filtersObject);
  }

  callsByFilter = [];

  private async fillGenericFilter(
    filter: filterStructure[],
    filterName: string,
    parameters: FilterParameters
  ): Promise<void> {
    // BN: MIGHT THE THIS
    // this.source = new AbortController();
    // if (this.source) {
    //   this.source.abort();
    // }

    const x = await storageService.getGenericFilter(
      filterName,
      parameters
      // this.source.signal
    );
    filter.splice(0, filter.length);
    if (x.data != null && x.data.length != 0) {
      x.data.forEach((element) => {
        filter.push({
          text: element.text,
          value: element.value,
        });
      });
    }
  }

  private hide(): void {
    this.drawer = !this.drawer;
  }

  private resetFilters(): void {
    //common
    this.filtersValue.includeGiancezaZero = false;
    this.filtersValue.onlyMoreThanFour = false;
    //codice
    this.filtersValue.codice = null;
    this.filtersValue.keywords = null;
    this.filtersValue.keywords2 = null;
    //categoria
    this.filtersValue.catalogueSourceID = null;
    this.filtersValue.brand = null;
    this.filtersValue.cartype = null;
    this.filtersValue.finitura = null;
    this.filtersValue.modelloRuota = null;
    this.filtersValue.fromYear = null;
    this.filtersValue.type = null;
    this.filtersValue.model = null;
    this.filtersValue.canale = null;
    this.filtersValue.diametro = null;
    this.filtersValue.fori = null;
    this.filtersValue.pcd = null;
    this.filtersValue.et_From = null;
    this.filtersValue.et_To = null;
    this.filtersValue.foroCentrale_From = null;
    this.filtersValue.foroCentrale_To = null;
    this.filtersValue.category = null;

    storageModule.setFilters(null);

    //  CLEANS FILTER VALUE PROPERLY
    this.canaleFilterValue = [];
    this.diametroFilterValue = [];
    this.foriFilterValue = [];
    this.pcdFilterValue = [];
    this.et_FromFilterValue = [];
    this.et_ToFilterValue = [];
    this.foroCentrale_FromFilterValue = [];
    this.foroCentrale_ToFilterValue = [];
    this.modelloRuotaFilterValue = [];
    this.fillAll();
  }

  private sendFilters(): void {
    if (this.filtersValue.requestType == 0) {
      this.filtersValue.codice = null;
      this.filtersValue.keywords = null;
      this.filtersValue.keywords2 = null;
    } else {
      this.filtersValue.catalogueSourceID = null;
      this.filtersValue.brand = null;
      this.filtersValue.model = null;
      this.filtersValue.cartype = null;
      this.filtersValue.modelloRuota = null;
      this.filtersValue.finitura = null;
      this.filtersValue.fromYear = null;
      this.filtersValue.type = null;
      this.filtersValue.tireDimension = null;
      this.filtersValue.height = null;
      this.filtersValue.category = null;
    }
    if (this.filtersValue.requestType == 0 && this.validate()) {
      storageModule.setFilters(this.filtersValue);
      this.drawer = !this.drawer;
      this.$emit("changeFilters", this.filtersValue, true);
    } else if (this.filtersValue.requestType != 0) {
      storageModule.setFilters(this.filtersValue);
      this.drawer = !this.drawer;
      this.$emit("changeFilters", this.filtersValue, true);
    } else {
      snackbarModule.showSnackbar({
        message: "Attenzione! I filtri non sono compilati correttamente",
        type: "error",
      });
      setTimeout(() => snackbarModule.hideSnackbar(), 5000);
    }
  }

  private validate(): boolean {
    return this.form.validate();
  }

  get isSafari(): boolean {
    // Used to apply 44px bottom of bar.
    const userAg = navigator.userAgent?.toLowerCase() ?? "";
    return userAg.indexOf("safari") != -1 || userAg.indexOf("ipad") != -1;
  }

  private checkCategorySelected(): boolean {
    return !["", "000", "001", "002"].includes(this.filtersValue.categoria);
  }
}
